export default __webpack_public_path__ + "static/media/logo_dhl.d6111cea.png";